/**
 * User-facing copy for backend Pricing Engine error/reason codes. Never
 * expose a raw backend reason code or internal error message to the
 * customer — this is the one place that translation happens, so every
 * consumer (CouponInput, CheckoutPage) shows identical, reviewed wording.
 */
import type { CouponInvalidReason } from './types';

const COUPON_REASON_COPY: Record<string, string> = {
  COUPON_NOT_FOUND: 'That coupon code doesn’t exist.',
  COUPON_EXPIRED: 'This coupon has expired.',
  COUPON_INACTIVE: 'This coupon is no longer active.',
  COUPON_USAGE_EXHAUSTED: 'This coupon has reached its usage limit.',
  COUPON_USER_LIMIT_REACHED: 'You’ve already used this coupon the maximum number of times.',
  COUPON_PRODUCT_NOT_ELIGIBLE: 'This coupon doesn’t apply to this product.',
  COUPON_MIN_ORDER_NOT_MET: 'This coupon requires a higher order amount.',
  COUPON_PARTNER_NOT_ELIGIBLE: 'Coupons cannot be applied to partner accounts.',
};

export function describeCouponReason(reason: CouponInvalidReason | undefined): string {
  if (reason && COUPON_REASON_COPY[reason]) return COUPON_REASON_COPY[reason];
  return 'Coupon is invalid or expired.';
}

export const PRICING_CALCULATION_FAILED_MESSAGE =
  'We couldn’t calculate your price. Please try again.';

export const PRODUCT_UNAVAILABLE_MESSAGE = 'This product is no longer available.';
